export default "__VITE_ASSET__6WEvdEcT__"